import script from "./present.vue?vue&type=script&setup=true&lang=js"
export * from "./present.vue?vue&type=script&setup=true&lang=js"

import "./present.vue?vue&type=style&index=0&id=3b284080&lang=scss"

const __exports__ = script;

export default __exports__